/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { ChangeEvent } from 'react'
import { Modal } from 'react-bootstrap-v5'
import { NumericFormat } from 'react-number-format'
import { SaleRowModel } from '../../../models/account-books/SalesAccount'
import { revertPriceNumner } from '../../../selectors'

type Props = {
  show: boolean
  mode: string
  data?: any
  onClose: () => void
  handleVerified: () => void
  handleUpdateData: (originData: SaleRowModel) => void
}

const CompareModal: React.FC<Props> = ({ show, data, onClose, handleVerified, handleUpdateData }) => {
  
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    let originData = {...data.origin_data};
    const fieldName = e.target.name;
    const value = revertPriceNumner(e.target.value);
    
    handleUpdateData({
      ...originData,
      [fieldName]: value
    })
  }

  return (
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header className='d-flex p-3'>
        <Modal.Title>Đối soát chi tiết hàng hóa</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-3">
        <div className='row'>
          <div className='col-6 col-md-6'>
            <div className='card'>
              <div className='card-header p-3 text-primary fw-bold' style={{minHeight: 'unset'}}>Dữ liệu Sento</div>
              <div className='card-body p-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>Số lượng</label>
                  <NumericFormat
                    name='sale_price'
                    thousandSeparator=","
                    className='form-control form-control-sm'
                    value={data?.origin_data?.quantity ?? 0}
                    onChange={(e) => handleChange(e)}
                    onBlur={(e) => handleChange(e)}
                  />
                </div>
                <div className='form-group mb-3'>
                  <label className='form-label'>Đơn giá</label>
                  <NumericFormat
                    name='sale_price'
                    thousandSeparator=","
                    className='form-control form-control-sm'
                    value={data?.origin_data?.unit_price ?? 0}
                    onChange={(e) => handleChange(e)}
                    onBlur={(e) => handleChange(e)}
                  />
                </div>
                <div className='form-group mb-3'>
                  <label className='form-label'>VAT</label>
                  <NumericFormat
                    name='sale_price'
                    thousandSeparator=","
                    className='form-control form-control-sm'
                    value={data?.origin_data?.vat_rate ?? 0}
                    onChange={(e) => handleChange(e)}
                    onBlur={(e) => handleChange(e)}
                  />
                </div>
                <div className='form-group'>
                  <label className='form-label'>Thành tiền</label>
                  <NumericFormat
                    name='sale_price'
                    thousandSeparator=","
                    className='form-control form-control-sm'
                    value={data?.origin_data?.line_amount ?? 0}
                    onChange={(e) => handleChange(e)}
                    onBlur={(e) => handleChange(e)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='col-6 col-md-6'>
            <div className='card'>
              <div className='card-header p-3 text-primary fw-bold' style={{minHeight: 'unset'}}>Dữ liệu gốc</div>
              <div className='card-body p-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>Số lượng</label>
                  <NumericFormat
                    name='sale_price'
                    thousandSeparator=","
                    className='form-control form-control-sm'
                    value={data?.origin_data?.quantity ?? 0}
                    onChange={(e) => handleChange(e)}
                    onBlur={(e) => handleChange(e)}
                  />
                </div>
                <div className='form-group mb-3'>
                  <label className='form-label'>Đơn giá</label>
                  <NumericFormat
                    name='sale_price'
                    thousandSeparator=","
                    className='form-control form-control-sm'
                    value={data?.origin_data?.unit_price ?? 0}
                    onChange={(e) => handleChange(e)}
                    onBlur={(e) => handleChange(e)}
                  />
                </div>
                <div className='form-group mb-3'>
                  <label className='form-label'>VAT</label>
                  <NumericFormat
                    name='sale_price'
                    thousandSeparator=","
                    className='form-control form-control-sm'
                    value={data?.origin_data?.vat_rate ?? 0}
                    onChange={(e) => handleChange(e)}
                    onBlur={(e) => handleChange(e)}
                  />
                </div>
                <div className='form-group'>
                  <label className='form-label'>Thành tiền</label>
                  <NumericFormat
                    name='sale_price'
                    thousandSeparator=","
                    className='form-control form-control-sm'
                    value={data?.origin_data?.line_amount ?? 0}
                    onChange={(e) => handleChange(e)}
                    onBlur={(e) => handleChange(e)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className='p-3'>
        <button className='btn btn-secondary btn-sm me-auto' onClick={onClose}>Hủy</button>
        <button className='btn btn-primary btn-sm' onClick={handleVerified}>Duyệt</button>
      </Modal.Footer>
    </Modal>
  )
}

export default CompareModal
